function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Splide from '@splidejs/splide';
document.addEventListener('DOMContentLoaded', function () {
  // Product list carousel
  var productListSplide = new Splide('.product-list', {
    type: 'loop',
    padding: {
      left: 0,
      right: '12rem'
    },
    perPage: 4,
    pagination: false,
    breakpoints: {
      1200: {
        perPage: 3,
        padding: {
          left: 0,
          right: '10rem'
        }
      },
      540: {
        perPage: 2,
        padding: 10
      }
    }
  });
  productListSplide.mount();

  // Showcase carousel
  var showCaseSplide = new Splide('.showcase', _defineProperty(_defineProperty(_defineProperty({
    type: 'loop',
    focus: 'center'
  }, "focus", 'center'), "autoWidth", true), "pagination", false));
  showCaseSplide.mount();

  // Columns Splide
  var columnsSplide = document.querySelectorAll('.columns__content.splide');
  columnsSplide.forEach(function (columnsElement) {
    var columnGap = parseInt(columnsElement.dataset.gap);
    var carouselPadding = columnsElement.classList.contains('columns__content--divider') ? '2rem' : {
      left: '24px',
      right: '12rem'
    };
    var columnsSplide = new Splide(columnsElement, {
      type: 'loop',
      padding: carouselPadding,
      focus: 'center',
      perPage: 1,
      pagination: false,
      autoHeight: true,
      mediaQuery: 'min',
      gap: columnGap,
      autoWidth: true,
      breakpoints: {
        1024: {
          destroy: true
        }
      }
    });
    columnsSplide.mount();
  });
});

// PDP Featured Recipes
(function () {
  'use strict';

  var selectors = {
    tab: '[data-tab]',
    tabPanel: '[data-tab-panel]',
    splide: '[data-recipe-splide]',
    thumb: '[data-recipe-thumb]',
    card: '[data-recipe-card]'
  };
  function PdpFeaturedRecipes(root) {
    this.root = root;
    this.splideInstances = {};
    this.tabButtons = Array.prototype.slice.call(root.querySelectorAll(selectors.tab));
    this.tabPanels = Array.prototype.slice.call(root.querySelectorAll(selectors.tabPanel));
    this.initTabs();
    this.initCardSelection();
  }
  PdpFeaturedRecipes.prototype.activateTab = function (tabKey, shouldFocus) {
    this.tabButtons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-tab') === tabKey;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      btn.setAttribute('tabindex', isActive ? '0' : '-1');
      if (isActive && shouldFocus) btn.focus();
    });
    this.tabPanels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-tab-panel') === tabKey;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
    this.initSplideInTab(tabKey);
  };
  PdpFeaturedRecipes.prototype.initTabs = function () {
    var self = this;
    this.tabButtons.forEach(function (button, index) {
      var tabKey = button.getAttribute('data-tab');
      button.addEventListener('click', function () {
        self.activateTab(tabKey);
      });
      button.addEventListener('keydown', function (event) {
        var newIndex = -1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          newIndex = index === 0 ? self.tabButtons.length - 1 : index - 1;
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          newIndex = index === self.tabButtons.length - 1 ? 0 : index + 1;
        } else if (event.key === 'Home') {
          newIndex = 0;
        } else if (event.key === 'End') {
          newIndex = self.tabButtons.length - 1;
        }
        if (newIndex !== -1) {
          event.preventDefault();
          var newTab = self.tabButtons[newIndex].getAttribute('data-tab');
          self.activateTab(newTab, true);
        }
      });
    });
    var firstActive = this.tabButtons.filter(function (btn) {
      return btn.classList.contains('is-active');
    })[0];
    if (firstActive) this.initSplideInTab(firstActive.getAttribute('data-tab'));
  };
  PdpFeaturedRecipes.prototype.initSplideInTab = function (tabKey) {
    if (typeof Splide === 'undefined') return;
    var thumbsPanel = this.root.querySelector('.pdp-featured-recipes__thumbs[data-tab-panel="' + tabKey + '"]');
    var splideEl = thumbsPanel ? thumbsPanel.querySelector(selectors.splide) : null;
    if (!splideEl) return;
    if (!this.splideInstances[tabKey]) {
      this.splideInstances[tabKey] = new Splide(splideEl, {
        type: 'slide',
        perPage: 4,
        gap: '32px',
        pagination: false,
        arrows: true,
        drag: true,
        breakpoints: {
          1160: {
            perPage: 3,
            gap: '20px'
          },
          768: {
            fixedWidth: '104px',
            gap: '8px',
            arrows: true
          }
        }
      }).mount();
    } else {
      this.splideInstances[tabKey].refresh();
    }
  };
  PdpFeaturedRecipes.prototype.initCardSelection = function () {
    var self = this;
    var thumbs = Array.prototype.slice.call(this.root.querySelectorAll(selectors.thumb));
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var thumbsPanel = thumb.closest(selectors.tabPanel);
        if (!thumbsPanel) return;
        var tabKey = thumbsPanel.getAttribute('data-tab-panel');
        var cardsPanel = self.root.querySelector('.pdp-featured-recipes__cards[data-tab-panel="' + tabKey + '"]');
        if (!cardsPanel) return;
        var panelThumbs = Array.prototype.slice.call(thumbsPanel.querySelectorAll(selectors.thumb));
        var panelCards = Array.prototype.slice.call(cardsPanel.querySelectorAll(selectors.card));
        var targetId = thumb.getAttribute('data-recipe-target');
        panelThumbs.forEach(function (t) {
          var isSelected = t === thumb;
          t.classList.toggle('is-selected', isSelected);
          t.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
        panelCards.forEach(function (card) {
          var isSelected = card.id === targetId;
          card.classList.toggle('is-active', isSelected);
          card.hidden = !isSelected;
        });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'click_recipe_card_featured_recipes',
          card_name: thumb.textContent.trim()
        });
      });
    });
  };
  function initPdpFeaturedRecipes() {
    var root = document.querySelector('[data-pdp-featured-recipes]');
    if (!root) return;
    new PdpFeaturedRecipes(root);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpFeaturedRecipes);
  } else {
    initPdpFeaturedRecipes();
  }
})();